import React, { useEffect, useState } from 'react'
import { rulesService } from '../../services/rulesService'
import { useAuthContext } from '../../hooks/useAuthContext'
import {
  Box,
  Button,
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material'
import { Delete, Edit } from '@mui/icons-material'
import RuleEditorDialog from '../Admin/RuleEngine/RuleEditorDialog'

const MyRulesets = () => {
  const { user } = useAuthContext()
  const [rules, setRules] = useState([])
  const [activities, setActivities] = useState([])
  const [editorOpen, setEditorOpen] = useState(false)
  const [selectedForEdit, setSelectedForEdit] = useState(null)

  const fetchRules = async () => {
    const rules = await rulesService.getUsersRules(user)
    setRules(rules)

    const activities = await rulesService.getActivities(user)
    setActivities(activities)
  }

  useEffect(() => {
    fetchRules()
  }, [])

  const handleDelete = async (ruleId) => {
    try {
      await rulesService.deleteRule(user, ruleId)
      await fetchRules()
    } catch (err) {}
  }

  return (
    <Box sx={{ padding: 2 }}>
      <Box
        display={'flex'}
        flexDirection={'row'}
        justifyContent={'space-between'}
        alignItems={'center'}
      >
        <Typography variant="p">My Rulesets</Typography>
        <Button onClick={() => setEditorOpen(true)} variant="contained">
          Add Rules
        </Button>
      </Box>
      {rules.length > 0 ? (
        <Box sx={{ mt: 2 }}>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>Name</TableCell>
                <TableCell>Trigger</TableCell>
                <TableCell>Process/Activity</TableCell>
                <TableCell>Expiry At</TableCell>
                <TableCell>Actions</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {rules.map((rule) => {
                return (
                  <TableRow>
                    <TableCell>{rule.name}</TableCell>
                    <TableCell>{rule.triggers.join(',')}</TableCell>
                    <TableCell>
                      {rule?.process_template_name}/{rule?.activity_template_name}
                    </TableCell>
                    <TableCell>{rule.valid_till || 'No Expiry'}</TableCell>
                    <TableCell>
                      <IconButton
                        onClick={() => {
                          setSelectedForEdit(rule)
                          setEditorOpen(true)
                        }}
                      >
                        <Edit style={{ fontSize: 16 }} />
                      </IconButton>
                      <IconButton onClick={() => handleDelete(rule.id)}>
                        <Delete style={{ fontSize: 16 }} />
                      </IconButton>
                    </TableCell>
                  </TableRow>
                )
              })}
            </TableBody>
          </Table>
        </Box>
      ) : (
        <Box
          width={'100%'}
          height={'300px'}
          display={'flex'}
          justifyContent={'center'}
          alignItems={'center'}
        >
          <Typography>No rules found!</Typography>
        </Box>
      )}

      <RuleEditorDialog
        open={editorOpen}
        onClose={() => {
          setSelectedForEdit(null)
          setEditorOpen(false)
        }}
        activities={activities}
        activityTemplateId={selectedForEdit?.activity_template_id}
        processTemplateId={selectedForEdit?.process_template_id}
        rules={rules}
      />
    </Box>
  )
}

export default MyRulesets
